import { render, staticRenderFns } from "./Promocode.vue?vue&type=template&id=1f1f58ca"
import script from "./Promocode.vue?vue&type=script&lang=js"
export * from "./Promocode.vue?vue&type=script&lang=js"
import style0 from "./Promocode.vue?vue&type=style&index=0&id=1f1f58ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports